import React, { useState, useMemo } from 'react';
import ClientProvider from '../../../Various/ClientProvider';
import { onlyUnique } from '../../../Various/TreeFilter/helpers'
import DataGrid, { TextEditor } from 'react-data-grid';

export default function MapString({ execAll, execAllArray, showAll, execSelected, commandKey }) {
    const wsProvider = React.useContext(ClientProvider);
    const type = wsProvider.CommandsTree.getSingleSetting("type")

    const getMappingData = () => {
        var data = wsProvider.CommandsTree.getSingleSetting("mappingData", {
            "items": {}
        })

        if (typeof data === 'string' || data instanceof String) {
            data = {
                "items": {}
            }
        }

        if (!data || !("items" in data)) {
            data["items"] = {}
        }

        return data
    }

    const getRowsFromData = () => {
        const data = getMappingData()
        const uniqueValues = Object.keys(execAll).map(x => execAll[x].in).filter(onlyUnique)

        const rows = uniqueValues.map(x => {
            return {
                "input": x,
                "replace": (x in data.items && data.items[x]["replace"]) ? data.items[x]["replace"] : null,
                "prefix": (x in data.items && data.items[x]["prefix"]) ? data.items[x]["prefix"] : null,
                "suffix": (x in data.items && data.items[x]["suffix"]) ? data.items[x]["suffix"] : null
            }
        })
        return rows
    }

    const [rows, setRows] = useState(getRowsFromData);

    const onRowsChangeHandler = (newRows, { indexes }) => {
        setRows(newRows)
        
        const data_existing = getMappingData()
        indexes.forEach(row_index => {
            const row = newRows[row_index]
            if (!(row["input"] in data_existing.items)) {
                data_existing.items[row["input"]] = {}
            }
            data_existing.items[row["input"]]["replace"] = row["replace"] || null
            data_existing.items[row["input"]]["prefix"] = row["prefix"] || null
            data_existing.items[row["input"]]["suffix"] = row["suffix"] || null

            if (!data_existing.items[row["input"]]["replace"] && !data_existing.items[row["input"]]["prefix"] && !data_existing.items[row["input"]]["suffix"]) {
                delete data_existing.items[row["input"]]
            }
        })

        wsProvider.CommandsTree.setSingleSetting("mappingData", data_existing)
    }

    const columns = useMemo(() => [{
        key: 'input',
        name: 'input',
        width: "25%",
        frozen: true,
    }, {
        key: 'replace',
        name: 'replace',
        width: "25%",
        editable: true,
        editor: TextEditor
    }, {
        key: 'prefix',
        name: 'prefix',
        width: "25%",
        editable: true,
        editor: TextEditor
    }, {
        key: 'suffix',
        name: 'suffix',
        width: "25%",
        editable: true,
        editor: TextEditor
    }], [])

    return (
        <DataGrid
            columns={columns}
            rows={rows}
            rowKeyGetter={(row) => row.input}
            className="rdg-dark"
            onRowsChange={onRowsChangeHandler}
        />)
}